import { createContext } from "react";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import { DEFAULT_FUNCTION, DEFAULT_QUERY } from "../../utils/helpers/constants";
import { IIncentiveQuery } from "../../models/incentive/query";
import {
  IIncentive,
  IIncentiveDetails,
} from "../../models/incentive/response";
import {
  ICreateIncentive,
  IUpdateIncentive,
} from "../../models/incentive/request";

export type IncentiveLoading =
  | "list"
  | "details"
  | "create"
  | "update"
  | "delete";

export interface IInternalState {
  loading: IncentiveLoading[];

  list?: IBaseListingResponse<IIncentive>;
  query: IIncentiveQuery;

  details?: IIncentiveDetails;
}

export const internalState: IInternalState = {
  loading: [],
  query: DEFAULT_QUERY,
};

export interface IExternalState extends IInternalState {
  actions: {
    getData: () => void;
    getDetails: (id: number) => void;
    setDetails: (data?: IIncentive) => void;

    createIncentive: (
      request: ICreateIncentive
    ) => void;
    updateIncentive: (
      id: number,
      request: IUpdateIncentive
    ) => void;
    deleteIncentive: (id: number) => void;
    exportExcel: (data: any) => any;

    setSearch: (search?: string) => void;
    setQuery: (query: IIncentiveQuery) => void;
  };
}

export const externalState: IExternalState = {
  ...internalState,
  actions: {
    getData: DEFAULT_FUNCTION,
    getDetails: DEFAULT_FUNCTION,
    setDetails: DEFAULT_FUNCTION,
    exportExcel: DEFAULT_FUNCTION,

    createIncentive: DEFAULT_FUNCTION,
    updateIncentive: DEFAULT_FUNCTION,
    deleteIncentive: DEFAULT_FUNCTION,

    setSearch: DEFAULT_FUNCTION,
    setQuery: DEFAULT_FUNCTION,
  },
};

const IncentiveContext = createContext(externalState);

export default IncentiveContext;
